import { hot } from 'react-hot-loader/root';
import { setConfig } from 'react-hot-loader';
import React from 'react';
import Shell from './components/Shell';
import { GlobalStyles, ShellThemeProvider } from 'venn-ui-kit';
import { LicenseManager, AgGridLicenseKey } from 'venn-components';
import { QueryClient, QueryClientProvider } from 'venn-utils';
import { RecoilRoot } from 'recoil';

setConfig({
  reloadHooks: false,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 24 * 60 * 60 * 1000, // 24h
    },
  },
});

LicenseManager.setLicenseKey(AgGridLicenseKey);

const App = () => {
  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <ShellThemeProvider>
          <Shell />
          <GlobalStyles />
        </ShellThemeProvider>
      </QueryClientProvider>
    </RecoilRoot>
  );
};

export default hot(App);
